import { Language } from '@ha/intl';

export const HowItWorksUrls = {
  renting: {
    [Language.en]: '/renting',
    [Language.de]: '/de/mieten',
    [Language.nl]: '/nl/huren',
    [Language.es]: '/es/buscar-alojamiento',
    [Language.it]: '/it/trova-casa',
    [Language.fr]: '/fr/trouver-logement',
  },
  rentingOut: {
    [Language.en]: '/renting-out',
    [Language.de]: '/de/vermieten',
    [Language.nl]: '/nl/verhuren',
    [Language.es]: '/es/buscar-inquilino',
    [Language.it]: '/it/trova-inquilino',
    [Language.fr]: '/fr/trouver-locataire',
  },
};
